import React from "react";
import styled from "styled-components";
import { resolveIconSize } from "@xsolla/xui-primitives-core";
import type { FlagIconInternalProps } from "./types";

const StyledFlagIcon = styled.div<{ $size: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$size};
  height: ${(props) => props.$size};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const FlagIcon: React.FC<FlagIconInternalProps> = ({
  size = 24,
  svgContent,
  className,
  style,
  "data-testid": testId,
  testID,
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden,
}) => (
  <StyledFlagIcon
    $size={resolveIconSize(size)}
    className={className}
    style={style}
    data-testid={testId || testID}
    role={ariaLabel ? "img" : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
    dangerouslySetInnerHTML={{ __html: svgContent }}
  />
);
